// Events
import { DOCUMENT_CLICK } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';

export default component((node, ctx) => {
  const { carousel } = choozy(node);
  const {
    collapsibleBlock: collapsibleBlocks = [],
    toggle: toggles = [],
    banner: banners = [],
  } = choozy(node, true);

  const setContentHeight = (_event, { isMobile } = window.theme) => {
    banners.find((banner) => banner.hasAttribute('open'))?.removeAttribute('open');
    banners.find((banner) => banner.hasAttribute('active'))?.removeAttribute('active');
    collapsibleBlocks.forEach((collapsibleBlock) => {
      collapsibleBlock.setAttribute(
        'style',
        `--content-height: ${
          collapsibleBlock.scrollHeight ||
          Array.from(collapsibleBlock.childNodes).reduce(
            (blockHeight, nodeHeight) => blockHeight + nodeHeight.scrollHeight,
            0,
          )
        }px;`,
      );
    });
    banners.forEach((banner) => {
      const { collapsibleBlock: bannerCollapsibleBlocks, container } = choozy(banner);
      const blocks = []
        .concat(bannerCollapsibleBlocks)
        .filter(
          (bannerCollapsibleBlock) =>
            (isMobile && !bannerCollapsibleBlock.matches('.hidden')) ||
            (!isMobile && bannerCollapsibleBlock.matches('.hidden')),
        );

      container?.setAttribute(
        'style',
        `--container-height: ${
          container.scrollHeight +
          (blocks.length ? Math.abs(blocks[0].scrollHeight - blocks[1].scrollHeight) : 0)
        }px;`,
      );
    });
  };

  const changeStatement = (event) => {
    const { currentTarget } = event;
    const { toggle: attribute } = currentTarget.dataset;
    const closestBanner = currentTarget.closest('[data-banner]');
    let { shortVideo: closestShortVideos = [], longVideo: closestLongVideos = [] } =
      choozy(closestBanner);

    closestShortVideos = [].concat(closestShortVideos);
    closestLongVideos = [].concat(closestLongVideos);

    closestBanner.toggleAttribute(attribute);

    if (attribute === 'active' && closestBanner.hasAttribute('active')) {
      closestBanner.removeAttribute('open');

      if (closestLongVideos.length) {
        closestLongVideos.forEach((video) => {
          video.currentTime = 0;
          video.play();
        });
      } else if (closestShortVideos.length) {
        closestShortVideos.forEach((video) => video.setAttribute('controls', ''));
      }
    } else if (attribute === 'open' && closestBanner.hasAttribute('open')) {
      carousel?.swiper?.disable();
    } else if (
      (attribute === 'open' && !closestBanner.hasAttribute('open')) ||
      (attribute === 'active' && !closestBanner.hasAttribute('active'))
    ) {
      carousel?.swiper?.enable();
      if (closestLongVideos.length) {
        closestLongVideos.forEach((video) => video.pause());
      } else if (closestShortVideos.length) {
        closestShortVideos.forEach((video) => video.removeAttribute('controls'));
      }
    }
  };

  setContentHeight();
  document.addEventListener('theme:screen:size-updated', setContentHeight);
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', changeStatement);
  });
  ctx.on(DOCUMENT_CLICK, (state, { event }) => {
    const closestBanner = event.target.closest('[data-banner]');
    const activeBanner = banners.find(
      (banner) => banner.hasAttribute('active') && banner !== closestBanner,
    );

    if (!closestBanner || (closestBanner && activeBanner && closestBanner !== activeBanner)) {
      const openBanner = banners.find((banner) => banner.hasAttribute('open'));
      let { shortVideo: activeShortVideos = [], longVideo: activeLongVideos = [] } =
        choozy(activeBanner);

      activeShortVideos = [].concat(activeShortVideos);
      activeLongVideos = [].concat(activeLongVideos);

      openBanner?.removeAttribute('open');
      carousel?.swiper?.enable();

      activeBanner?.removeAttribute('active');
      if (activeLongVideos.length) {
        activeLongVideos.forEach((video) => video.pause());
      } else if (activeShortVideos.length) {
        activeShortVideos.forEach((video) => video.removeAttribute('controls'));
      }
    }
  });
});
